import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import sanityClient from "../client.js";

export default function Projects() {
  // Use useState and useEffect to fetch data from Sanity.io
  const [postData, setPost] = useState(null);

  useEffect(() => {
    // Take all data
    sanityClient
      .fetch(
        `*[_type == "post"]{
      title,
      slug,
      mainImage {
        asset->{
          _id,
          url
        },
        alt
      }
    }`
      )
      .then((data) => setPost(data))
      // Log the error if any
      .catch(console.error);
  }, []);

  if (!postData) {
    return (
      <div className="flex justify-center p-40 loading-text">Loading...</div>
    );
  }

  return (
    <main>
      {/* Main section begins */}
      <section>
        <div className="blog-container">
          {postData &&
            postData.map((post, index) => (
              <Link to={"/blog/" + post.slug.current} key={post.slug.current}>
                <span className="blog-item">
                  <img
                    src={post.mainImage.asset.url}
                    alt={post.mainImage.alt}
                    className="post-image"
                  />
                </span>
                <span style={{ textAlign: "center", color: "#ffffff" }}>
                  <h3>{post.title}</h3>
                </span>
              </Link>
            ))}
        </div>
      </section>
    </main>
  );
}
